<template>
  <div class="lift-step-three">
    <v-switch
      v-model="form.headrest_module.idc_headrest"
      hide-details
      label="têtière :"
      class="title"
      @change="clearHeadrestFields"
    />
    <v-layout
      wrap
      justify-space-between
      mt-6
    >
      <v-flex sm6>
        <v-layout
          column
          justify-space-between
          fill-height
        >
          <div class="radios-container">
            <v-radio-group
              v-model="form.headrest_module.renew"
              hide-details
              row
              class="mb-4"
              :disabled="!form.headrest_module.idc_headrest"
            >
              <v-radio
                label="Existant"
                value="EXISTING"
              />
              <v-radio
                label="Nouveau"
                value="NEW"
              />
            </v-radio-group>

            <v-radio-group
              v-model="form.headrest_module.type"
              hide-details
              row
              :disabled="!form.headrest_module.idc_headrest"
            >
              <v-radio
                label="Amovible"
                value="REMOVABLE"
              />
              <v-radio
                label="Réglable"
                value="ADJUSTABLE"
              />
              <v-radio
                label="Intégré"
                value="EMBEDDED"
              />
            </v-radio-group>
          </div>
          <div class="content img1">
            <div class="img-container">
              <img src="@/assets/img/schema_verticalisateur_3a.svg">
              <v-text-field
                v-model="form.headrest_module.a"
                v-validate="'numeric|max:4'"
                data-vv-name="(Têtière) Schema A"
                :class="{ error: errors.has('(Têtière) Schema A') }"
                type="number"
                style="top: 23.1%;left: 42.2%;"
                height="100%"
                :disabled="!form.headrest_module.idc_headrest"
                outlined
              />
              <v-text-field
                v-model="form.headrest_module.b"
                v-validate="'numeric|max:4'"
                data-vv-name="(Têtière) Schema B"
                :class="{ error: errors.has('(Têtière) Schema B') }"
                type="number"
                style="top: 79%;left: 42.2%;"
                height="100%"
                :disabled="!form.headrest_module.idc_headrest"
                outlined
              />
            </div>
          </div>
        </v-layout>
      </v-flex>

      <v-flex sm6>
        <v-radio-group
          v-model="form.headrest_module.headrest_type"
          hide-details
          class="mb-4"
          :disabled="!form.headrest_module.idc_headrest"
        >
          <v-layout
            class="checkbox-input-container mb-3"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Albatros"
                value="ALBATROS"
                :disabled="!form.headrest_module.idc_headrest"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.headrest_module.albatros_size"
                :items="headrestModule.albatros"
                item-text="label"
                item-value="value"
                label="Taille Albatros"
                hide-details
                filled
                clearable
                :disabled="
                  !form.headrest_module.idc_headrest ||
                    form.headrest_module.headrest_type !== 'ALBATROS'
                "
                @click:clear="
                  $nextTick(() => (form.headrest_module.albatros_size = null))
                "
              />
            </v-flex>
          </v-layout>
          <v-radio
            label="Moulé"
            value="MOULDED"
            class="mb-4"
          />
          <v-radio
            label="Sur mesure"
            value="CUSTOM_MADE"
          />
        </v-radio-group>
        <v-switch
          v-model="form.headrest_module.idc_thierry"
          hide-details
          label="Thierry"
          class="mb-4"
          :disabled="!form.headrest_module.idc_headrest"
        />

        <v-layout mb-3>
          <v-text-field
            v-model="form.headrest_module.finishing"
            label="Finition"
            hide-details
            outlined
            maxlength="15"
            :disabled="!form.headrest_module.idc_headrest"
          />
        </v-layout>

        <v-select
          v-model="form.headrest_module.mounting"
          :items="headrestModule.mounting"
          item-text="label"
          item-value="value"
          label="Fixation :"
          class="mb-3"
          hide-details
          filled
          clearable
          :disabled="!form.headrest_module.idc_headrest"
          @click:clear="$nextTick(() => (form.headrest_module.mounting = null))"
        />

        <v-layout justify-space-between>
          <v-radio-group
            v-model="form.headrest_module.mounting_type"
            hide-details
            row
            class="mb-4"
            :disabled="!form.headrest_module.idc_headrest"
          >
            <v-radio
              label="Tube carré"
              value="SQUARE_TUBE"
            />
            <v-radio
              label="En fer Plat"
              value="FLAT_IRON"
            />
          </v-radio-group>
        </v-layout>

        <v-select
          v-model="form.headrest_module.vital_scrolling"
          :items="headrestModule.vital_scrolling"
          item-text="label"
          item-value="value"
          label="Vital"
          hide-details
          filled
          clearable
          :disabled="!form.headrest_module.idc_headrest"
          @click:clear="
            $nextTick(() => (form.headrest_module.vital_scrolling = null))
          "
        />
      </v-flex>
    </v-layout>
    <v-layout
      justify-center
      align-center
      class="mt-12"
    >
      <div class="content img2">
        <div class="img-container">
          <img
            class="mb-5"
            src="@/assets/img/schema_siegemoule_6b.svg"
          >
          <v-text-field
            v-model="form.headrest_module.c"
            v-validate="'numeric|max:4'"
            data-vv-name="(Têtière) Schema C"
            :class="{ error: errors.has('(Têtière) Schema C') }"
            type="number"
            style="top: 22.6%;left: 88.1%;"
            height="125%"
            :disabled="!form.headrest_module.idc_headrest"
            outlined
          />
        </div>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LiftStepThree",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType",

      headrestModule: "dropdowns/getHeadRestOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear headrest fields
    clearHeadrestFields() {
      this.form.headrest_module.renew = null;
      this.form.headrest_module.type = null;
      this.form.headrest_module.headrest_type = null;
      this.form.headrest_module.albatros_size = null;
      this.form.headrest_module.mounting_type = null;
      this.form.headrest_module.idc_thierry = false;
      this.form.headrest_module.vital_scrolling = null;
      this.form.headrest_module.finishing = null;
      this.form.headrest_module.mounting = null;
      this.form.headrest_module.a = null;
      this.form.headrest_module.b = null;
      this.form.headrest_module.c = null;
    }
  }
};
</script>

<style lang="scss">
.lift-step-three {
  .content {
    display: flex;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 15.8%;
          height: 17.8%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 11.8%;
          height: 21.8%;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
}
</style>
